// extracted by mini-css-extract-plugin
export default {"actions":"EditActu_actions__BvHt7","secondary":"EditActu_secondary__0EX5u","field":"EditActu_field__pc-jS","row":"EditActu_row__Nn99J","meta":"EditActu_meta__i2dPI"};